import { Modal, ModalProp } from "../../components/modal/Modal";
import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { PointAdjustHistory } from "../../model/PointData";
import { SetStateAction } from "react";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { Company } from "../../model/Companies";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { requestExecuteAdjust } from "../../api/Point.api";
import pointDataQuery from "../../firestore/PointData.query";

export type ExecutionModalProps = {
  inputData: PointAdjustHistory;
  setLoadProgress: (value: SetStateAction<number>) => void;
  setIsExecutionModalOpen: (value: React.SetStateAction<boolean>) => void;
  company: Company | undefined;
  setIsExecution: (value: React.SetStateAction<boolean>) => void;
  checkedList: string[];
  setExecutionErrFlg: (value: React.SetStateAction<boolean>) => void;
  checkedUserRow: GridRow[];
};

export const ExecutionModal = ({
  open,
  toggle,
  closeOnClickOutside,
  inputData,
  setLoadProgress,
  setIsExecutionModalOpen,
  company,
  setIsExecution,
  checkedList,
  setExecutionErrFlg,
  checkedUserRow,
}: ModalProp & ExecutionModalProps) => {

  const dispatch = useDispatch();

  // 選択した利用者一覧の項目
  const targetUserCols: GridCol[] = [
    {
      field: "userId",
      headerName: "利用者番号",
      style: "w-1/6",
      sort: false
    },
    {
      field: "name",
      headerName: "名前",
      style: "w-1/6",
      sort: false
    },
    {
      field: "beforePoint",
      headerName: "調整前ポイント数",
      style: "w-1/6",
      sort: false
    },
    {
      field: "afterPoint",
      headerName: "調整後ポイント数",
      style: "w-1/6",
      sort: false
    },
  ];

  // 調整実行処理
  const executionHandler = async () => {
    setIsExecutionModalOpen(false);
    executionData();
  };

  const executionData = async () => {
    try {
      if (!company) return;

      setLoadProgress(0);
      const tenantId = company.id;
      const pointAdjustHistoryRef = await pointDataQuery.createPointAdjustHistory(tenantId, inputData);
      await new Promise(resolve => setTimeout(resolve, 3000));
      setLoadProgress(20);

      const total = checkedList.length;
      const pageSize = 5000;
      let processed = 0;

      for (let i = 0; i < total; i += pageSize) {
        const batch = checkedList.slice(i, i + pageSize);

        const result = await requestExecuteAdjust(
          tenantId,
          { ...inputData, id: pointAdjustHistoryRef.id },
          batch
        );

        if (result.success) {
          if (result.results && result.results.some(r => {
            const err = r.error;
            return err && (
              err === ConstMessage.IMPORT_ERR_USER_ID_NOT_EXIST ||
              err === ConstMessage.IMPORT_ERR_NOT_FOUD_USER_LAST_NAME ||
              err === ConstMessage.IMPORT_ERR_USER_ACCOUNTSUSPENSION
            );
          })) {
            setExecutionErrFlg(true);
          }
        } else {
          console.error("バッチ処理失敗:", result.error);
          dispatch(alertOpen(AlertValue("処理に失敗しました。", "danger")));
          break;
        }

        await new Promise(resolve => setTimeout(resolve, 3000));

        processed += batch.length;
        const progress = 20 + Math.round((processed / total) * 70);
        setLoadProgress(Math.min(progress, 90));
      };
      setIsExecution(true);
      setLoadProgress(100);
    } catch (e: any) {
      console.error(e);
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_SAVE, "danger")));
      setLoadProgress(-1);
      setIsExecution(false);
    };
  };

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:w-full max-w-screen-md">
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title as="h3" className="text-left text-lg font-medium leading-6 text-gray-900">
                調整実行確認
              </Dialog.Title>
            </div>
            <div className="mt-5">
              {inputData.ptCategoryName}のポイント調整を実行してもよろしいですか。
            </div><br/>
            <div className={'text-red-500'}>
              ※処理操作は、件数によって<span className={"font-bold text-red-700"}>作業時間が長時間になる場合があります。</span><br />
              また一度操作を開始すると途中で中止することはできません。
            </div>
          </div>
          <div className="mx-2 mb-2">
            <div className="ml-2">対象者</div>
            <TableList
              gridCol={targetUserCols}
              gridRow={checkedUserRow}
              footer={false}
              lineHeight={"py-2"}
              minWidth={"max-h-[230px] overflow-auto pt-1"}
            />
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-36 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              onClick={executionHandler}
              children={"OK"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  );  
}
  